import React from 'react'
import { useSelector } from 'react-redux'
import './styles.scss'
import Button from '../buttons/Button'
import close from './../../images/close-white.svg'
import chartIco from './../../images/chart-ico.svg';
import arrowsIco from './../../images/arrows-ico.svg';
import plateIco from './../../images/plate-ico.svg';
import moneyIco from './../../images/money-ico.svg';
import lockIco from './../../images/lock-ico.svg';
import puzzleIco from './../../images/puzzle-ico.svg';
import phoneIco from './../../images/phone-ico.svg';
import globusIco from './../../images/globus.svg';
import getDataFromUrl from './../../services/getDataFromUrl';

const ModalAxa = ( props ) => {
    let callNumber      = useSelector(state => state.callNumber);
    let k = getDataFromUrl("k");

    const downloadFile = () => {
        const   link = document.createElement("a");
                link.href = 'https://media.grenke.com/download/downloadgateway.dll/getfile?p_inst_id=32279944&p_session_id=&p_obt_id=2694014&p_spec_id=1';
                link.download = 'Warunki ubezpieczenia.pdf';
                link.click();
        
    }
    return (
        <div className="static-modal">
            <div className="modal">
                <div className="content">
                    <div className="icons-wrap">
                        <img src={ close } alt="Zamknij" onClick={ () => props.closeModal() } />
                    </div>
                    <div className="col">
                        <div className="text roman">
                            <h2>Korzyści ubezpieczenia AXA</h2>
                            <h3>{ props.data.title }</h3>
                            <ul>
                                { props.data.list.map( ( el, key ) => (
                                    <li className={ key}>{ el } </li>
                                ))}
                            </ul>
                            <p>{ props.data.text }</p>
                            <h3>Obowiązek ubezpieczenia</h3>
                            <p>
                                Korzystający ma obowiązek ubezpieczenia przedmiotu umowy przez cały okres trwania umowy oraz poniesienia kosztów tego ubezpieczenia.
                            </p>
                            <p>
                                Przedmiot umowy zostanie włączony do Ramowego Ubezpieczenia Majątkowego realizowanego przez AXA Versicherung AG (Niemcy), z wyłączeniem: wózków widłowych, minikoparek, paneli solarnych, kontenerów fotowoltaicznych, zbiorników paliw oraz oprogramowania (innego niż oprogramowanie systemowe), które zobowiązani są Państwo ubezpieczyć samodzielnie. Mogą Państwo w każdym momencie ubezpieczyć przedmiot umowy we własnym zakresie. Należy wówczas przedstawić GRENKE dowód zawarcia ubezpieczenia przedmiotu umowy na rzecz GRENKE.
                            </p>
                            <p>
                                Szczegółowe informacje uzyskasz, kontaktując się z przedstawicielem GRENKE.
                            </p>
                        </div>
                        <div className="call">
                            <div className="icon">
                                <img src={ phoneIco } alt=""/>
                            </div>
                            <div className="data">
                                <p>W przypadku pytań zadzwoń do GRENKE</p>
                                {/* <a href="tel:+32 508 11 30">+32 / 508 11 30</a> */}
                                {!callNumber && k !== "dok" &&
                                    <a href="tel: 61 872 37 00">61 / 872 37 00</a>
                                }
                                {!callNumber && k == "dok" &&
                                    <a href="tel: 61 872 37 51">61 / 872 37 51</a>
                                }
                                {callNumber &&
                                    <a href={"tel:" + callNumber.replace('/', '')}>{ callNumber }</a>
                                }
                            </div>
                        </div>
                        <div className="download">
                            <Button class="blue" setFunction={ () => downloadFile() } downloadWhite title="Pobierz ogólne warunki ubezpieczenia" />
                        </div>
                    </div>
                    <div className="col">
                        <div className="icons">
                            <div className="icon">
                                <img src={ arrowsIco } alt=""/>
                                <h2>Szeroka i kompleksowa ochrona</h2>
                                <p>
                                    Obejmuje m.in. kradzież, działanie siły wyższej oraz ochronę na wypadek przepięcia
                                </p>
                            </div>
                            <div className="icon">
                                <img src={ globusIco } alt=""/>
                                <h2>Międzynarodowy zasięg dla sprzętu mobilnego</h2>
                                <p>
                                    Ochrona sprzętu mobilnego na całym świecie
                                </p>
                            </div>
                            <div className="icon">
                                <img src={ plateIco } alt=""/>
                                <h2>Komfort i wygoda</h2>
                                <p>
                                    Automatycznie zawierane ubezpieczenie, formalnościami zajmuje się Grenke
                                </p>
                            </div>
                            <div className="icon">
                                <img src={ moneyIco } alt=""/>
                                <h2>Błyskawiczna likwidacja szkody</h2>
                                <p>
                                    Nachmiastowa reakcja na zgłoszoną szkodę oraz procedowanie wypłaty odszkodowania 
                                </p>
                            </div>
                            <div className="icon">
                                <img src={ lockIco } alt=""/>
                                <h2>Ochrona przez cały okres leasingu</h2>
                                <p>
                                Automatycznie odnawiane ubezpieczenie - w każdym roku przez cały okres trwania umowy
                                </p>
                            </div>
                            <div className="icon">
                                <img src={ puzzleIco } alt=""/>
                                <h2>Jakość i zaufanie</h2>
                                <p>
                                    Aż 93% Klientów, przy okazji finansowania w Grenke, korzysta z ubezpieczenia realizowanego przez AXA 
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ModalAxa;